export default "__VITE_ASSET__99a8cdc3__"